var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from 'react';
import { isEmpty } from '../../util';
import { TextField } from '../TextField';
import { getCardTypeByValue, PLACEHOLDER } from './cardTypes';
import { Container, NeedHelpLink } from './elements';
import { processCreditCardNumber } from './util';
export var CreditCardField = React.forwardRef(function (_a, fRef) {
    var needHelpHref = _a.needHelpHref, needHelpLabel = _a.needHelpLabel, _b = _a.affixRight, affixRight = _b === void 0 ? null : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, affixRightClickable = _a.affixRightClickable, label = _a.label, fieldStatus = _a.fieldStatus, helperText = _a.helperText, value = _a.value, onChange = _a.onChange, _d = _a.containerClassName, containerClassName = _d === void 0 ? 'CreditCardFieldContainer' : _d, restProps = __rest(_a, ["needHelpHref", "needHelpLabel", "affixRight", "disabled", "affixRightClickable", "label", "fieldStatus", "helperText", "value", "onChange", "containerClassName"]);
    var needHelpHrefPresent = !isEmpty(needHelpHref);
    //This is being used to store the card number that is being shown to user
    var _e = useState(''), cardFieldValue = _e[0], setCardFieldValue = _e[1];
    //Used to store the real card number
    var _f = useState((value !== null && value !== void 0 ? value : '').toString()), cardNumber = _f[0], setCardNumber = _f[1];
    var _g = useState({ min: 16, max: 16 }), length = _g[0], setLength = _g[1];
    var _h = useState(PLACEHOLDER), cardType = _h[0], setCardType = _h[1];
    var _j = useState(false), isOnFocus = _j[0], setIsOnFocus = _j[1];
    var _k = useState(fieldStatus), status = _k[0], setStatus = _k[1];
    var _l = useState(helperText), message = _l[0], setMessage = _l[1];
    var updateCardDetails = function (paymentCardType, ccNumber, isOnFocus) {
        if (paymentCardType === void 0) { paymentCardType = cardType; }
        if (ccNumber === void 0) { ccNumber = cardNumber; }
        if (isOnFocus === void 0) { isOnFocus = true; }
        var processResult = processCreditCardNumber(paymentCardType, ccNumber, !isOnFocus);
        setCardNumber(processResult.cardNumber);
        setCardFieldValue(processResult.creditCardFieldValue);
        if (isOnFocus) {
            //Generic Card error should be shown even on focus
            if (cardType.type === 'generic' &&
                processResult.cardNumber.length > 4) {
                setStatus('error');
                setMessage(processResult.errorMessage);
            }
            else {
                setStatus('default');
                setMessage('');
            }
        }
        else {
            if (processResult.errorMessage &&
                processResult.cardNumber.length > 0 &&
                (!helperText || helperText.length === 0)) {
                setStatus('error');
                setMessage(processResult.errorMessage);
            }
            else {
                setStatus(fieldStatus);
                setMessage(helperText);
            }
        }
        return processResult;
    };
    var onCardNumberChange = function (ev) {
        var value = ev.target.value;
        var cardTypeObject = getCardTypeByValue(value || '');
        setCardType(cardTypeObject);
        var _a = updateCardDetails(cardTypeObject, value), cardNumber = _a.cardNumber, errorMessage = _a.errorMessage;
        Object.assign(ev.target, {
            cardType: cardTypeObject.type,
            value: cardNumber,
            errorMessage: errorMessage
        });
        onChange === null || onChange === void 0 ? void 0 : onChange(ev);
    };
    var setInputLength = function () {
        //This variable is used to include the separators while calculating field length
        var gaps = cardType.gaps.length;
        setLength({
            min: cardType.lengths[0] + gaps,
            max: cardType.lengths[cardType.lengths.length - 1] + gaps
        });
    };
    useEffect(function () {
        setStatus(fieldStatus);
    }, [fieldStatus]);
    useEffect(function () {
        setMessage(helperText);
    }, [helperText]);
    useEffect(function () {
        updateCardDetails(cardType, value === null || value === void 0 ? void 0 : value.toString(), isOnFocus);
    }, [value]);
    useEffect(function () {
        updateCardDetails(cardType, cardNumber, isOnFocus);
    }, [isOnFocus]);
    useEffect(function () {
        setInputLength();
    }, [cardType]);
    return (React.createElement(Container, { "$disabled": disabled },
        React.createElement(TextField, __assign({}, restProps, { value: cardFieldValue, containerClassName: containerClassName, ref: fRef, type: 'text', affixRight: affixRight, disabled: disabled, affixRightClickable: affixRightClickable, inputMode: "numeric", maxLength: length.max, minLength: length.min, label: label, affixPaymentBadge: cardType.type, onChange: function (ev) {
                onCardNumberChange(ev);
            }, onFocus: function () {
                setIsOnFocus(true);
            }, onBlur: function () {
                setIsOnFocus(false);
            }, fieldStatus: status, helperText: message, affixRightIconClassName: 'CreditCardRightIcon', affixPaymentBadgeAltText: cardType.displayName })),
        needHelpHrefPresent && (React.createElement(NeedHelpLink, { href: needHelpHref, color: "secondary", disabled: disabled, className: disabled ? 'disabled' : '' }, needHelpLabel !== null && needHelpLabel !== void 0 ? needHelpLabel : 'Need Help?'))));
});
